module.exports = __webpack_public_path__ + "img/FB11_Biobank_logo.a53b785a.png";